import backButtonIcon from '@/assets/app/images/icon/icon-back-button_2.png';
import { useNavigate } from 'react-router';
import React from 'react'; // ReactNode 타입을 위해 추가

interface HeaderProps {
  title: string;
  onBack?: () => void;
  themeColor?: string;
  children?: React.ReactNode; // 우측 버튼이나 텍스트를 넣을 수 있는 공간 추가
}

const TitleHeader = ({ title, onBack, themeColor, children }: HeaderProps) => {
  const navigate = useNavigate();
  return (
    <header
      className={`relative flex items-center justify-center h-14 w-full bg-white px-4 theme-${themeColor ? themeColor : 'common'}`}
    >
      <button
        className="absolute left-4 btn-back-theme theme-color-border f-one-pop"
        onClick={onBack}
      >
        뒤로가기
      </button>

      <h1 style={{ fontSize: 24, fontWeight: 800, color: '#4B4B4B' }}>{title}</h1>

      {/* 우측에 전달된 children(설정 버튼 등)이 있다면 절대 위치로 배치 */}
      {children && (
        <div className="absolute right-4 top-1/2 -translate-y-1/2 flex items-center">
          {children}
        </div>
      )}
    </header>
  );
};

export default TitleHeader;
